export default "__VITE_ASSET__CrSQ4TkL__"